import z from 'zod'

import { MAX_VAT_EXEMPTION_MENTION_LENGTH } from '../../../constants/maxVatExemptionMentionLength'
import { VatExemptionMentionModalFormSchema } from '../types/vatExemptionMentionModalFormSchema'

export const getVatExemptionMentionModalFormSchema = (): VatExemptionMentionModalFormSchema => {
  return z.object({
    vatExemptionScheme: z.string().max(MAX_VAT_EXEMPTION_MENTION_LENGTH),
  })
}
